import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useRef } from 'react';
import BaseModal, { modalSizes } from 'flow/components/ui-components/BaseModal';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import UserRegionDropdown from '../region-lookup/UserRegionDropdown';
import Icon from '../ui-components/Icon';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { useUserRegionData } from 'flow/hooks/region-lookup/useUserRegionData';
import { createReturnUrl, MSGOO_APP_REG_DEFAULT_VALUE } from 'flow/utils/social-integration-utils';
import { electronListeners } from 'flow/utils/electron-utils';
import { startExternalSignIn } from 'flow/actions/social-integration-actions';
import isElectron from 'is-electron';
import { startCtiExternalSignIn } from 'flow/route-components/cti-sso';
import { SYNC_SOURCE } from 'flow/utils/constants/app-constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var UserRegionSelectorModal = function UserRegionSelectorModal() {
  var _useAppContext = useAppContext(),
    i18next = _useAppContext.i18next;
  var _useUserRegionData = useUserRegionData(),
    regionData = _useUserRegionData.regionData,
    updateRegionData = _useUserRegionData.updateRegionData;
  var _useModal = useModal(),
    closeModal = _useModal.closeModal;
  var dispatch = useAppDispatch();
  var socialLoginTypeRef = useRef(regionData === null || regionData === void 0 ? void 0 : regionData.socialLoginType);
  var electronSignInProcess = function electronSignInProcess(socialLoginType, appRegId) {
    electronListeners.checkIfExternalSignInFinished(dispatch);
    var callbackUrl = createReturnUrl('dummy', socialLoginType);
    dispatch(startExternalSignIn(socialLoginType, callbackUrl, appRegId));
  };
  var startSignIn = function startSignIn() {
    var socialLoginType = socialLoginTypeRef.current;
    if (regionData && socialLoginType) {
      var appRegId = MSGOO_APP_REG_DEFAULT_VALUE;
      if (socialLoginType === SYNC_SOURCE.google || socialLoginType === SYNC_SOURCE.microsoft) {
        updateRegionData(_objectSpread(_objectSpread({}, regionData), {}, {
          socialLoginType: socialLoginType,
          url: regionData === null || regionData === void 0 ? void 0 : regionData.socialSelectedUrl
        }));
        if (isElectron()) {
          electronSignInProcess(socialLoginType, appRegId);
        } else {
          startCtiExternalSignIn(socialLoginType, appRegId);
        }
      }
    }
  };
  return /*#__PURE__*/_jsx(BaseModal, {
    open: true,
    ariaLabel: i18next.t('signin.social.region.unsuccess'),
    modalSize: modalSizes.SMALL,
    hideCancelButton: false,
    confirmButtonText: i18next.t('signin.social.region.button.retry'),
    onSubmit: startSignIn,
    onClose: closeModal,
    isFooterActionsMultiRow: true,
    mainClassName: 'max-h-[calc(100%-240px)] md:max-h-[calc(100%-140px)]',
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col gap-y-3 px-2",
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/_jsx(Icon, {
          className: "text-lg",
          style: {
            width: 48,
            height: 48
          },
          iconKey: "globeQuestion"
        })
      }), /*#__PURE__*/_jsx("p", {
        className: "text-sm",
        children: i18next.t('signin.social.region.unsuccess')
      }), /*#__PURE__*/_jsx(UserRegionDropdown, {
        isModal: true
      })]
    })
  });
};
export default UserRegionSelectorModal;